import React, { useState, useEffect } from 'react';
import { getAuth, sendEmailVerification, signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../Components/LoginForm';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const VerifyEmail = () => {
  const [emailSent, setEmailSent] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const auth = getAuth();
  const [activeTab, setActiveTab] = useState('login');
  const navigate = useNavigate();

  useEffect(() => {
    // Si hay un usuario autenticado, obtenemos su email
    if (auth.currentUser) {
      setUserEmail(auth.currentUser.email);
    }
  }, [auth]);

  const handleResendEmail = async () => {
    if (auth.currentUser) {
      try {
        await sendEmailVerification(auth.currentUser);
        setEmailSent(true);
        toast.success("Email de verificación reenviado. Por favor revisa tu correo");

        console.log(`Email de verificación reenviado a ${userEmail}. Por favor revisa tu correo.`);
      } catch (error) {
        console.error('Error al reenviar el correo de verificación:', error);
        toast.error("Hubo un error al enviar el correo de verificación. Por favor intenta de nuevo.");

      }
    }
  };

  const handleSignOut = async () => {
    try {
      await signOut(auth);
      //<LoginForm handleTabChange={setActiveTab} />
      //navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <div className="verify-email-container">
       <ToastContainer />

      <h2>Verifica tu correo electrónico</h2>
      <p>
        Hemos enviado un enlace de verificación al correo <strong>{userEmail}</strong>. 
        Por favor, verifica tu correo y sigue el enlace para confirmar tu cuenta.
      </p>
      <button onClick={handleResendEmail} disabled={emailSent}>
        {emailSent ? 'Email reenviado' : 'Reenviar email de verificación'}
      </button>
      <button type='button' onClick={handleSignOut}>Cerrar sesión</button>
    </div>
  );
};

export default VerifyEmail;
